import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'

import { PageQuery, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { RewardsHubCampaignsHistoryDto } from '@model/RewardsHubCampaignsHistoryDto'

export const useCampaignsHistory = (
  query?: PageQuery
): {
  campaignsHistory: RewardsHubCampaignsHistoryDto[]
  isLoading: boolean
} => {
  const apiClient = useApiClient(ClientApiClient)

  const paginatedQuery = usePaginatedQuery<RewardsHubCampaignsHistoryDto>({
    queryKey: [...queryKeys.rewardsHub.campaignsHistory(), query],
    queryFn: () => apiClient.getRewardsHubCampaignsHistory(query),
  })

  return { campaignsHistory: paginatedQuery.data, isLoading: paginatedQuery.isLoading }
}
